import styles from './Cart.module.scss';
import CartItems from "./CartItems/CartItems";
import { motion, AnimatePresence } from "framer-motion"

function Cart(props) {
  const width = props.width;
  
  return (
    <>
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 50 }} // Start from 50px below the bottom
        animate={{ opacity: 1, y: 0 }} // Slide up to its original position
        transition={{ duration: 0.3 }}
        exit={{ opacity: 0, y: 50 }}
        style={{
          position: 'absolute',
          bottom: 0,
          width: '100%'
        }}
      >
        {props.currentStep < 2 && (
          <div className={styles["cart-container"]} style={{/*width:props.width + 'px'*/}}> 
            <div className={styles["cart-inner-container"]}>
              <>
                <CartItems
                  selectedServices={props.selectedServices}
                  onServiceDeSelect={props.onServiceDeSelect}
                />
                {props.currentStep === 1 ? (
                  <button
                    className={styles["cart-book-button"]}
                    isselected="no"
                    onClick={props.onBook}
                  >
                    {props.stepBetween1and2Loading ? 'Loading...' : `PRENOTA ${props.selectedServices.length} SERVIZI`}
                  </button>
                ) : (
                  <button
                    className={styles["cart-book-button"]}
                    isselected="no"
                    onClick={props.onBook}
                  >
                    {props.selectedServices.length > 0 ? 'CONTINUA' : 'CONTINUA SENZA AGGIUNGERE'}
                  </button>
                )}
              </>
            </div>
          </div>
        )}
        {props.currentStep === 2 && props.selectedTime && (
          <AnimatePresence>
            <motion.div
              initial={{ opacity: 0, y: 50 }} // Start from 50px below the bottom
              animate={{ opacity: 1, y: 0 }} // Slide up to its original position
              transition={{ duration: 0.3 }}
              exit={{ opacity: 0, y: 50 }}
              style={{
                position: 'absolute',
                bottom: 0,
                width: '100%'
              }}
            >
              <div className={styles["cart-container"]} style={{/*width:props.width + 'px'*/}}> 
                <div className={styles["cart-inner-container"]}>
                  <button
                    className={styles["cart-book-button"]}
                    isselected="no"
                    onClick={props.onBook}
                  >
                    PROCEDI
                  </button>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        )}
        {props.currentStep === 3 && !props.finished && (
          <AnimatePresence>
            <motion.div
              initial={{ opacity: 0, y: 50 }} // Start from 50px below the bottom
              animate={{ opacity: 1, y: 0 }} // Slide up to its original position
              transition={{ duration: 0.3 }}
              exit={{ opacity: 0, y: 50 }}
              style={{
                position: 'absolute',
                bottom: 0,
                width: '100%'
              }}
            >
              <div className={styles["cart-container"]} style={{/*width:props.width + 'px'*/}}> 
                <div className={styles["cart-inner-container"]}>
                  <button
                  className={styles["confirm-book-button"]}
                  isselected="no"
                  onClick={() => {
                    props.setConfirmButtonClicked(true);
                    props.trigger();
                    props.handleOnBookStep3();
                  }}
                >
                  {!props.isInFlight ? (
                    !props.payOnline ? 'CONFERMA PRENOTAZIONE' : 'CONFERMA e paga PRENOTAZIONE') : 'Loading...'}
                </button>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        )}
      </motion.div>
    </AnimatePresence>
    </>
  );
}

export default Cart;
